"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.acquisition = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("../../../3rd_party_libraries/fuelux/wizard.js");
require("jquery-address");
const CategoryChooser_1 = require("../../../TdWebtoolkitControls/controls/CategoryChooser/CategoryChooser");
const ChecklistControls_1 = require("../../../TdWebtoolkitControls/controls/Checklist/ChecklistControls");
require("../../../TdWebtoolkitControls/controls/List/List");
const List_1 = require("../../../TdWebtoolkitControls/controls/List/List");
require("../../../TdWebtoolkitControls/controls/Menu/MethodManager");
const synerisMethods_1 = require("../../../TdWebtoolkitControls/controls/Menu/synerisMethods");
require("../../../TdWebtoolkitControls/controls/Preview/Preview");
require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
const PropertyPage_1 = require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
require("../../../TdWebtoolkitControls/controls/Tabs/Tabs");
require("../../../TdWebtoolkitControls/controls/Upload/Templates");
require("../../../TdWebtoolkitControls/controls/Upload/Upload");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const Base_1 = require("../../../TdWebtoolkitControls/model/Base");
const Instance_1 = require("../../../TdWebtoolkitControls/model/Instance");
const PropertyPageModel_1 = require("../../../TdWebtoolkitControls/model/PropertyPageModel");
require("../SynView");
require("./acquisition.tmpl.less");
const $ = require("jquery");
const m = require("../SynView");
const r_conf = require("../acquisition/acquisition.config");
let _ = require("underscore");
let r_acquisitionTemplate = require("./acquisition.tmpl.htm");
let r_acquisitionStepTemplate = require("./acquisition.steps.tmpl.htm");
var AttachmentMode;
(function (AttachmentMode) {
    AttachmentMode[AttachmentMode["None"] = 0] = "None";
    AttachmentMode[AttachmentMode["File"] = 1] = "File";
    AttachmentMode[AttachmentMode["Metadata"] = 2] = "Metadata";
})(AttachmentMode || (AttachmentMode = {}));
var Mode;
(function (Mode) {
    Mode[Mode["PropertyPage"] = 1] = "PropertyPage";
    Mode[Mode["Checklist"] = 2] = "Checklist";
})(Mode || (Mode = {}));
class acquisition extends m.SynView {
    //#endregion MEMBER letIABLES
    //#region CONTRUCTORS
    constructor() {
        super();
        this.m_hasMenu = false;
    }
    //#endregion CONTRUCTORS
    //#region MEMBER METHODS
    //#region Inherited from SynView
    // Initialization of member variables
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.m_config = r_conf.acquisitionConfig;
        this.m_remainingFileGUIDs = [];
        this.m_forceMetadata = false;
        this.m_attachmentMode = AttachmentMode.File;
        this.m_fileUploaded = false;
        this.m_recreateEditWebsocket = false;
        this.icon = "fa-pencil";
        this.m_allowTemplates = false;
    }
    deactivate() {
        this.unregisterEditWebsocket();
        super.deactivate();
    }
    onWindowFocus() {
        if (this.m_editWebsocket && this.m_editWebsocket.readyState === WebSocket.OPEN) {
            this.m_editWebsocket.send(JSON.stringify({ command: "checkValid" }));
        }
    }
    getParametersFromUrl() {
        // Acquisition doesn't use parameters, the SynView call would set m_id to undefined, so we have to override it
    }
    renderContents() {
        let that = this;
        that.m_$categoryChooser = that.m_$container.find(".CategoryChooser");
        that.m_$templateChooser = that.m_$container.find(".TemplateChooser");
        that.m_$openDocuments = that.m_$container.find(".opendocuments");
        that.m_$openDocumentList = that.m_$container.find(".documentlist");
        that.m_$wizardContainer = that.m_$container.find(".wizardContainer");
        that.m_$heading = that.m_$container.find(".acquisitionHeading");
        that.m_$saveButtons = that.m_$container.find(".saveButtons");
        that.m_$categoryChooser
            .off("initSuccess").on("initSuccess", function () {
            let categorySelected = $(this).synCategoryChooser("getSelectedCategory");
            that.m_typeId = categorySelected.id.toString();
            that.initWidgets();
        })
            .off("categorySelectedManually").on("categorySelectedManually", function (evt, cat) {
            that.m_typeId = cat.id.toString();
            that.initWidgets();
        })
            .synCategoryChooser({
            showIcons: true,
            showTreeButton: true,
            showDependsCheckbox: false,
            usedIn: CategoryChooser_1.ChooserUsedInAcquisition,
            selectionCookieName: "acquisition"
        });
        that.m_$templateChooser.off("templateSelected").on("templateSelected", function (sender, template) {
            if (that.m_mode !== Mode.Checklist || (that.m_mode === Mode.Checklist && template["prodid"] === "41003"))
                that.setNewButtonVisibility(true);
            else
                that.setNewButtonVisibility(false);
        })
            .off("templateUnselected").on("templateUnselected", function () {
            that.setNewButtonVisibility(false);
        })
            .synTemplates();
    }
    forceRefresh(modificationInfo) { }
    //#endregion Inherited from SynView
    //#region Helpers
    initWidgets() {
        let that = this;
        let categoryCount = that.m_$categoryChooser.synCategoryChooser("getCategoryCount");
        if (categoryCount > 1)
            that.m_$categoryChooser.removeClass("hide");
        else
            that.m_$categoryChooser.addClass("hide");
        if (that.m_typeId) {
            if (Utilities_1.synUtil.Configs.getValue("acquisition.initstep", "metadata", parseInt(that.m_typeId, 10)) === "checklist")
                that.m_mode = Mode.Checklist;
            else
                // Fallback Step Metadata
                that.m_mode = Mode.PropertyPage;
            let initCallback = function (catCount, templCount) {
                that.setURL();
                that.m_$heading.html(kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("acquisition.heading", undefined, parseInt(that.m_typeId, 10))));
                // Check for open documents and add them to the listview datasource
                that.addOpenDocumentsForCategory(that.m_typeId, function (itemCount) {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        that.raiseOnViewResize();
                        if (itemCount > 0 || catCount > 1 || templCount > 1)
                            yield that.initOpenDocuments();
                        else
                            yield that.initWizard(undefined);
                    });
                });
            };
            that.m_allowTemplates = Utilities_1.synUtil.Configs.getValue("acquisition.allowtemplates", "N", parseInt(that.m_typeId, 10)) === "Y";
            if (that.m_allowTemplates)
                that.m_$templateChooser.removeClass("hide");
            else
                that.m_$templateChooser.addClass("hide");
            that.m_$templateChooser.synTemplates("setCategory", +that.m_typeId);
            that.m_$templateChooser.one("templatesReceived", () => {
                let templateCount = that.m_$templateChooser.synTemplates("getTemplateCount");
                if (that.m_allowTemplates && templateCount > 1)
                    that.m_$templateChooser.removeClass("hide");
                else
                    that.m_$templateChooser.addClass("hide");
                if (that.m_mode === Mode.Checklist) {
                    that.setNewButtonVisibility(false);
                    if (templateCount < 2)
                        Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("acquisitionnotemplatesetforchecklist"));
                }
                else
                    that.setNewButtonVisibility(true);
                initCallback(categoryCount, templateCount);
            });
        }
        else
            that.m_$templateChooser.addClass("hide");
    }
    initWizard(docId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            if (!that.m_typeId)
                that.m_typeId = that.m_$categoryChooser.synCategoryChooser("getSelectedCategory").id.toString();
            that.m_tagNameNew = Utilities_1.synUtil.Configs.getValue("webtoolkit.acquisition.layout.tagname.new." + that.m_typeId, "Default");
            that.m_tagNameEdit = Utilities_1.synUtil.Configs.getValue("webtoolkit.acquisition.layout.tagname.edit." + that.m_typeId, "Default");
            that.m_id = docId;
            that.m_fileUploaded = false;
            that.m_$openDocuments.addClass("hide");
            that.m_$wizardContainer.removeClass("hide");
            let typeId = parseInt(that.m_typeId, 10);
            let template = kendo.template(r_acquisitionStepTemplate);
            let wizardStepsMarkup = $(template({
                synUtil: Utilities_1.synUtil,
                typeId
            }));
            let buttonText = {
                previous: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("acquisition.step.previous", undefined, typeId)),
                next: Utilities_1.synUtil.escapeHTMLAttribute(Utilities_1.synUtil.Strings.getValue("acquisition.step.next", undefined, typeId)),
                submit: Utilities_1.synUtil.escapeHTMLAttribute(Utilities_1.synUtil.Strings.getValue("acquisition.submit.button", undefined, typeId)),
                cancel: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("acquisition.document.cancel", undefined, typeId)),
                save: Utilities_1.synUtil.Strings.getValue("menuok"),
                revert: Utilities_1.synUtil.Strings.getValue("menucancel")
            };
            if ("desktop" !== that.m_clientDeviceClass) {
                buttonText.previous = "";
                buttonText.next = "";
                buttonText.cancel = "X";
            }
            let wizardMarkup = "<div class='wizard'><ul class='steps'></ul>" +
                "<div class='actions'>" +
                "<button type='button' class='btn btn-success btn-prev'><i class='fa fa-arrow-left'></i> " + buttonText.previous + "</button>" +
                "<button type='button' class='btn btn-success btn-next' data-last='" + buttonText.submit + "'>" + buttonText.next + " <i class='fa fa-arrow-right'></i></button>" +
                "<button type='button' class='btn btn-link btn-cancel'>" + buttonText.cancel + "</button>" +
                "<button type='button' class='btn btn-success btn-save hide'><i class='fa fa-file-text-o'></i> " + buttonText.save + "</button>" +
                "<button type='button' class='btn btn-link btn-revert hide'>" + buttonText.revert + "</button>" +
                "</div>" +
                "<div class='step-content'></div></div>";
            // if (that.m_typeId !== that.m_oldTypeid) { /* Wizard must be rebuilded */
            // that.m_oldTypeid = that.m_typeId;
            if (that.m_$wizard && that.m_$wizard.data("fu.wizard")) {
                // Destroy Wizard before building new one
                that.m_$wizard.wizard("destroy");
                that.m_$wizard.remove();
            }
            that.m_$wizardContainer.append(wizardMarkup);
            that.m_$wizard = that.m_$wizardContainer.find(".wizard");
            that.m_$wizard.wizard();
            // Register Events
            that.m_$wizard.off("changed.fu.wizard").on("changed.fu.wizard", function (evt, data) {
                let currentStepName = that.m_steps[data.step - 1];
                if (data.step < that.m_steps.length)
                    that.m_$wizard.find(".btn-next").removeClass("btn-danger").addClass("btn-success");
                else
                    that.m_$wizard.find(".btn-next").addClass("btn-danger").removeClass("btn-success");
                that.enableNextStep(that.m_id != undefined);
                if ("download" === currentStepName)
                    that.initStepDownload();
                else if ("upload" === currentStepName) {
                    that.initStepUpload();
                    if (Utilities_1.synUtil.Configs.getValue("acquisition.upload", "", parseInt(that.m_typeId, 10)) === "F" && !that.m_fileUploaded)
                        that.enableNextStep(false);
                }
                else if ("attachments" === currentStepName)
                    that.initStepAttachments();
                else if ("edit" === currentStepName)
                    that.initStepEdit();
                // Disable websocket on all other steps
                if ("edit" !== currentStepName)
                    that.unregisterEditWebsocket();
            });
            that.m_$wizard.off("finished.fu.wizard").on("finished.fu.wizard", function (evt, data) {
                let submitstate = Utilities_1.synUtil.Configs.getValueMandatory("acquisition.submitstate", parseInt(that.m_typeId, 10));
                if (submitstate) {
                    let saveInstanceCallback = function () {
                        Utilities_1.synUtil.getInstance(that.m_id, function (instance) {
                            instance.items["cgdocument.stateid"].value = submitstate;
                            Utilities_1.synUtil.getAJAXData({
                                method: "POST",
                                url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                                requestData: { instance: JSON.stringify(instance.toJSON()) },
                                done(data) {
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew"));
                                    that.m_id;
                                    that.initWidgets();
                                }
                            });
                        });
                    };
                    if (that.m_mode === Mode.Checklist) {
                        Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("InstanceUndoCheckOut") + that.m_id,
                            done() {
                                saveInstanceCallback();
                            }
                        });
                    }
                    else
                        saveInstanceCallback();
                }
            });
            that.m_$wizard.find(".btn-cancel").off("click").on("click", function () {
                if (that.m_mode === Mode.Checklist) {
                    if (that.m_checklistAction === ChecklistControls_1.ChecklistAction.New)
                        that.initWidgets();
                    else {
                        Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("InstanceUndoCheckOut") + that.m_id,
                            done() {
                                that.initWidgets();
                            }
                        });
                    }
                }
                else {
                    let inst = that.m_$propertyPage.synPropertyPage("getInstance");
                    if (!inst || !inst.items["cgdocument.docid"].value)
                        window.location.reload();
                    else {
                        Utilities_1.synUtil.choice({
                            allowCancel: true,
                            text: Utilities_1.synUtil.Strings.getValue("acquisition.deleteorkeep"),
                            options: [
                                {
                                    id: 1,
                                    text: Utilities_1.synUtil.Strings.getValue("menudelete"),
                                }, {
                                    id: 2,
                                    text: Utilities_1.synUtil.Strings.getValue("acquisition.keep"),
                                }
                            ],
                        }).then((id) => {
                            if (id === 1)
                                that.deleteDocument(that.m_id);
                            else if (id === 2)
                                window.location.reload();
                        });
                    }
                }
            });
            that.m_steps = [];
            if (Utilities_1.synUtil.Configs.getValue("acquisition.initstep", "metadata", parseInt(that.m_typeId, 10)) === "checklist") {
                that.m_mode = Mode.Checklist;
                that.addStep("checklist", wizardStepsMarkup);
                that.initStepChecklist();
                that.m_checklistAction = ChecklistControls_1.ChecklistAction.New;
            }
            else {
                // Fallback Step Metadata
                that.m_mode = Mode.PropertyPage;
                that.addStep("metadata", wizardStepsMarkup);
                that.initStepMetadata();
            }
            // Add optional steps based on configuration
            if (Utilities_1.synUtil.Configs.getValue("acquisition.edit", "N", parseInt(that.m_typeId, 10)) === "Y")
                that.addStep("edit", wizardStepsMarkup);
            if (Utilities_1.synUtil.Configs.getValue("acquisition.download", "Y", parseInt(that.m_typeId, 10)) === "Y")
                that.addStep("download", wizardStepsMarkup);
            if (Utilities_1.synUtil.Configs.getValue("acquisition.upload", "Y", parseInt(that.m_typeId, 10)) !== "N")
                that.addStep("upload", wizardStepsMarkup);
            if ("Y" === Utilities_1.synUtil.Configs.getValue("acquisition.hasattachments", undefined, parseInt(that.m_typeId, 10)))
                that.addStep("attachments", wizardStepsMarkup);
            that.enableNextStep(that.m_id != undefined);
            let categoryCount = that.m_$categoryChooser.synCategoryChooser("getCategoryCount");
            let templateCount = that.m_$templateChooser.synTemplates("getTemplateCount");
            if ((that.m_mode === Mode.Checklist && templateCount < 2 && that.m_openDocumentsDS && that.m_openDocumentsDS.total() === 0) ||
                (that.m_mode === Mode.PropertyPage && categoryCount < 2 && that.m_openDocumentsDS && that.m_openDocumentsDS.total() === 0))
                that.enableCancel(false);
            // Always start with metadata
            that.m_$wizard.wizard("selectedItem", { step: 1 });
            if (that.m_id) {
                if (that.m_mode === Mode.Checklist) {
                    that.m_checklistAction = ChecklistControls_1.ChecklistAction.Edit;
                    that.m_checklistId = that.m_id;
                    let checklistInstanceUrl = Utilities_1.synUtil.getWSUrl("ChecklistGetInstance");
                    Utilities_1.synUtil.getAJAXData({
                        method: "POST",
                        url: checklistInstanceUrl,
                        requestData: JSON.stringify({ id: that.m_checklistId, checkout: true, fordesigner: false, action: ChecklistControls_1.ChecklistAction.Edit }),
                        done(instance) {
                            that.m_$checklistEditorPage.synChecklist("setInstance", instance, undefined, ChecklistControls_1.ChecklistMode.Editor, false, ChecklistControls_1.ChecklistAction.Edit);
                        },
                        fail(jqXHR, textStatus, errorThrown, url) {
                            Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url, false);
                        }
                    });
                }
                else {
                    yield that.m_$propertyPage.synPropertyPage("setInstance", {
                        id: that.m_id,
                        mode: Base_1.PropertyPageMode.Edit,
                        tagName: that.m_tagNameEdit
                    });
                }
            }
            else {
                if (that.m_allowTemplates)
                    that.m_templateId = that.m_$templateChooser.synTemplates("getSelectedTemplateId");
                else
                    that.m_templateId;
                if (that.m_mode === Mode.Checklist) {
                    if (that.m_typeId) {
                        let templateId;
                        templateId = that.m_$templateChooser.synTemplates("getSelectedTemplateId");
                        if (!templateId && templateCount === 2) {
                            that.m_$templateChooser.synTemplates("selectIndex", 1);
                            templateId = that.m_$templateChooser.synTemplates("getSelectedTemplateId");
                        }
                        if (templateId) {
                            that.m_checklistId = templateId;
                            let checklistInstanceUrl = Utilities_1.synUtil.getWSUrl("ChecklistGetInstance");
                            Utilities_1.synUtil.getAJAXData({
                                method: "POST",
                                url: checklistInstanceUrl,
                                requestData: JSON.stringify({ id: that.m_checklistId, checkout: false, fordesigner: false, action: ChecklistControls_1.ChecklistAction.New }),
                                done(instance) {
                                    that.m_$checklistEditorPage.synChecklist("setInstance", instance, undefined, ChecklistControls_1.ChecklistMode.Editor, false, ChecklistControls_1.ChecklistAction.New);
                                },
                                fail(jqXHR, textStatus, errorThrown, url) {
                                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url, false);
                                }
                            });
                        }
                    }
                }
                else {
                    that.m_$propertyPage.synPropertyPage("setTemplate", {
                        mode: 4,
                        typeId: that.m_typeId,
                        parentId: undefined,
                        parentRelId: undefined,
                        tagName: that.m_tagNameNew
                    });
                }
            }
        });
    }
    initStepMetadata() {
        let that = this;
        that.m_$propertyPage = that.m_$wizardContainer.find(".metadataPropertyPage");
        if (that.m_$propertyPage.data("synPropertyPage"))
            that.m_$propertyPage.synPropertyPage("destroy");
        that.m_$propertyPage
            .on("valuesChanged", function (event) {
            that.activateButtons();
            that.editDocument(true);
        })
            .on("valuesReverted", function (event) {
            that.editDocument(false);
        })
            .synPropertyPage({
            layout: "desktop" === that.m_clientDeviceClass ? "absolute" : "table",
        });
    }
    initStepChecklist() {
        let that = this;
        that.m_$checklistEditorPage = that.m_$wizardContainer.find(".checklistEditor");
        that.m_$checklistEditorPage
            .on("checklistSet", function (event) {
            that.activateButtons();
        })
            .on("checklistChanged", function (event) {
            that.editDocument(true);
        })
            .synChecklist();
    }
    registerEditWebsocket() {
        let that = this;
        if (("WebSocket" in window || "MozWebSocket" in window) && that.m_editWebsocket == undefined) {
            let socketUrl = window.location.toString();
            socketUrl = socketUrl.substr(0, socketUrl.length - window.location.hash.length);
            socketUrl = socketUrl.replace(/^http/, "ws") + "Websocket?csrfToken=" + Utilities_1.synUtil.requestVerificationToken;
            that.m_editWebsocket = new WebSocket(socketUrl);
            that.m_editWebsocket.addEventListener("open", function () {
                that.m_recreateEditWebsocket = true;
                let docId = that.m_id.split("|")[1];
                let sendData = {
                    command: "registerListener",
                    docId,
                    eTag: that.m_eTag
                };
                that.m_editWebsocket.send(JSON.stringify(sendData));
            });
            that.m_editWebsocket.addEventListener("close", function (ev) {
                that.m_editWebsocket;
                if (that.m_recreateEditWebsocket)
                    that.registerEditWebsocket();
            });
            that.m_editWebsocket.addEventListener("message", function (ev) {
                try {
                    // let propertyPage = that.m_$tabs.synTabs("getPropertyPage");
                    let docId = that.m_id.split("|")[1];
                    let msg = JSON.parse(ev.data);
                    let etag = msg.changedObjects[docId];
                    if (etag && that.m_eTag !== etag) {
                        Utilities_1.synUtil.getInstance(that.m_id, function (instance) {
                            that.m_eTag = instance.items["cgdocument.etag"].valueAsString;
                            if (instance.items["cgdocument.chkout"].value)
                                that.enableCheckin();
                            else
                                that.enableCheckout();
                        });
                    }
                }
                catch (e) {
                    "Method not implemented.";
                }
            });
            that.m_editWebsocket.addEventListener("error", function (ev) {
                // error
            });
        }
    }
    unregisterEditWebsocket() {
        let that = this;
        that.m_recreateEditWebsocket = false;
        if (that.m_editWebsocket)
            that.m_editWebsocket.close();
    }
    enableCheckout() {
        let that = this;
        that.m_$wizardContainer.find("button.checkout").show();
        that.m_$wizardContainer.find("button.checkin").hide();
        that.enableNextStep(true);
    }
    enableCheckin() {
        let that = this;
        that.m_$wizardContainer.find("button.checkout").hide();
        that.m_$wizardContainer.find("button.checkin").show();
        that.enableNextStep(false);
    }
    initStepEdit() {
        let that = this;
        that.m_$wizardContainer.find("button.checkout").off("click").on("click", function () {
            synerisMethods_1.synerisMethods.cefunc["28"].impl([that.m_id], undefined, undefined, undefined, undefined);
        }).hide();
        that.m_$wizardContainer.find("button.checkin").off("click").on("click", function () {
            synerisMethods_1.synerisMethods.cefunc["62"].impl([that.m_id], undefined, undefined, undefined);
        }).hide();
        Utilities_1.synUtil.getInstance(that.m_id, function (instance) {
            that.m_eTag = instance.items["cgdocument.etag"].valueAsString;
            if (instance.items["cgdocument.chkout"].value)
                that.enableCheckin();
            else
                that.enableCheckout();
            that.registerEditWebsocket();
        });
    }
    initStepUpload() {
        let that = this;
        that.m_$upload = that.m_$wizard.find(".uploadContainer");
        if (that.m_$upload.hasClass("synUpload")) {
            that.m_$upload.synUpload("destroy");
            that.m_$upload.removeClass("synUpload");
            that.m_$upload.append("<input name='files' type='file' class='uploadTextbox' />");
        }
        that.m_$upload
            .off("uploadComplete").on("uploadComplete", function () {
            let guids = that.m_$upload.synUpload("getFileGuids");
            if (guids.length > 0) {
                Utilities_1.synUtil.executeMethod({
                    method: "cefunc.63",
                    additionalData: { fileGUIDs: guids.join(";") },
                    ids: [that.m_id],
                    parentId: undefined,
                    relId: undefined,
                    done() {
                        Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("contentreplaced"));
                        that.m_fileUploaded = true;
                        that.enableNextStep(true);
                        that.m_$upload.synUpload("clearList");
                    }
                });
            }
        })
            .synUpload({ allowMultiple: false });
        that.m_$upload.find(".k-upload-button > span").prepend($("<i class='fa fa-upload k-button-icon' />"));
    }
    initStepAttachments() {
        let that = this;
        let attachmentsRelId = parseInt(Utilities_1.synUtil.Configs.getValue("acquisition.attachments.relid", "1" /* RELATION_ALL */, parseInt(that.m_typeId, 10)));
        let $attachmentList = that.m_$wizard.find(".attachmentList");
        let $attachmentUploadContainer = that.m_$wizard.find(".attachmentUploadContainer");
        let $addMetadataButton = that.m_$wizard.find(".addMetadataButton");
        let $attachmentCategoryChooser = that.m_$wizard.find(".attachmentCategoryChooser");
        let $attachmentListContainer = that.m_$wizard.find(".attachmentListContainer");
        let $attachmentPropertyPage = that.m_$wizard.find(".attachmentPropertyPage");
        let $attachmentPropertyPageContainer = that.m_$wizard.find(".attachmentPropertyPageContainer");
        // Init Upload
        if (!($attachmentUploadContainer.hasClass("synUpload"))) {
            $attachmentUploadContainer
                .off("uploadComplete").on("uploadComplete", function () {
                let fileGUIDs = $attachmentUploadContainer.synUpload("getFileGuids");
                if (fileGUIDs.length > 0) {
                    if (that.m_forceMetadata)
                        createAttachmentsWithMetadata(fileGUIDs);
                    else
                        createAttachmentsWithoutMetadata(fileGUIDs);
                }
            })
                .off("fileRemoved").on("fileRemoved", function (event, data) {
                let fileGUIDs = $attachmentUploadContainer.synUpload("getFileGuids");
                if (that.m_forceMetadata)
                    createAttachmentsWithMetadata(_.without(fileGUIDs, data.deleteGUIDs));
            })
                .synUpload({ allowMultiple: true });
            $attachmentUploadContainer.find(".k-upload-button > span").prepend("<i class='fa fa-upload k-button-icon' />");
        }
        // Init Metadata
        $addMetadataButton.off("click").on("click", function () {
            createMetaOnlyAttachments();
        });
        // Hide buttons initially
        $attachmentUploadContainer.hide();
        $addMetadataButton.hide();
        let createMetaOnlyAttachments = function () {
            // Override global button handler
            let activateButtons = function () {
                let eventHandler = "click";
                if ("ontouchstart" in document.documentElement)
                    eventHandler = "touchstart";
                that.m_$wizard.find(".actions").find(".btn-save").off(eventHandler).on(eventHandler, doSavePropertyAttachments);
                that.m_$wizard.find(".actions").find(".btn-revert").off(eventHandler).on(eventHandler, function () {
                    if (Utilities_1.synUtil.Configs.getValue("webconfirmcancel") !== "N") {
                        if (window.confirm(Utilities_1.synUtil.Strings.getValue("confirmcancel")))
                            backtoList();
                    }
                    else
                        backtoList();
                });
            };
            $attachmentPropertyPageContainer.find(".attachmentPropertyPageHeader").html("");
            $attachmentPropertyPageContainer.removeClass("hide");
            $attachmentListContainer.addClass("hide");
            if (!($attachmentPropertyPage.data("synPropertyPage"))) {
                $attachmentPropertyPage
                    .on("valuesChanged", function () {
                    activateButtons();
                })
                    .on("valuesReverted", function () {
                    that.showSaveButtons(false);
                })
                    .synPropertyPage({
                    layout: "desktop" === that.m_clientDeviceClass ? "absolute" : "table"
                });
            }
            $attachmentPropertyPage.synPropertyPage("setTemplate", {
                mode: Base_1.PropertyPageMode.New /* New */,
                typeId: $attachmentCategoryChooser.synCategoryChooser("getSelectedCategory").id,
                parentId: that.m_id,
                parentRelId: attachmentsRelId,
                tagName: that.m_tagNameNew
            });
            activateButtons();
            that.showSaveButtons(true);
            let backtoList = function () {
                $attachmentPropertyPageContainer.addClass("hide");
                $attachmentListContainer.removeClass("hide");
                $attachmentUploadContainer.synUpload("clearList");
                loadTabContent();
                that.showSaveButtons(false);
            };
            let doSavePropertyAttachments = function (event) {
                if (!that.m_saveInProgress) {
                    that.m_saveInProgress = true;
                    let saveBtn = that.m_$wizard.find(".actions").find(".btn-save");
                    Utilities_1.synUtil.beginAjaxProgress(saveBtn);
                    $attachmentPropertyPage.synPropertyPage("commitChanges", {
                        templateId: that.m_templateId,
                        success(currentInstance, commitResult) {
                            switch (commitResult) {
                                case PropertyPage_1.CommitSuccess.Saved:
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                                    break;
                                case PropertyPage_1.CommitSuccess.Created:
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew"));
                                    setTimeout(function () { backtoList(); }, 250);
                                    break;
                                case PropertyPage_1.CommitSuccess.NoChanges:
                                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("nochanges"));
                                    break;
                                default:
                                    break;
                            }
                        },
                        cleanUp() {
                            that.m_saveInProgress = false;
                            Utilities_1.synUtil.endAjaxProgress(saveBtn);
                        },
                        updatePropertyPageAfterCommit: true
                    });
                }
            };
        };
        let showHideAttachmentButtons = function (mode) {
            $attachmentUploadContainer.hide();
            $addMetadataButton.hide();
            if (mode & AttachmentMode.File)
                $attachmentUploadContainer.show();
            if (mode & AttachmentMode.Metadata)
                $addMetadataButton.show();
        };
        let createAttachmentsWithMetadata = function (fileGUIDs) {
            let attachmentsRelId = Utilities_1.synUtil.Configs.getValue("acquisition.attachments.relid", "1" /* RELATION_ALL */, parseInt(that.m_typeId));
            that.m_remainingFileGUIDs = _.clone(fileGUIDs);
            $attachmentPropertyPageContainer.removeClass("hide");
            $attachmentListContainer.addClass("hide");
            let getPrefilledTemplateInstance = function (callback) {
                let requestOptions = {
                    typeId: $attachmentCategoryChooser.synCategoryChooser("getSelectedCategory").id,
                    mode: 4 /* NEW */,
                    parentId: that.m_id.toString()
                };
                if (attachmentsRelId)
                    requestOptions.parentRelId = attachmentsRelId;
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("PropertypageControlsTemplate"),
                    requestData: requestOptions,
                    done(propertyPageJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            callback(yield PropertyPageModel_1.PropertyPageModel.fromJSON(propertyPageJSON));
                        });
                    }
                });
            };
            let initAttachmentPropertyPage = function () {
                if (!($attachmentPropertyPage.data("synPropertyPage"))) {
                    $attachmentPropertyPage
                        .on("valuesChanged", function () {
                        activateButtons();
                    })
                        .on("valuesReverted", function () {
                        that.showSaveButtons(false);
                    })
                        .on("instanceChanged", function () {
                        // that.m_propertyPageWindow.center();
                    })
                        .synPropertyPage({
                        layout: "desktop" === that.m_clientDeviceClass ? "absolute" : "table"
                    });
                }
                getPrefilledTemplateInstance(function (propertyPage) {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        let attachmentTypeId = $attachmentCategoryChooser.synCategoryChooser("getSelectedCategory").id;
                        let filefieldname = Utilities_1.synUtil.Configs.getValue("acquisition.attachments.filefieldname", "cgdocument.doclabel", attachmentTypeId);
                        let fileGUID = that.m_remainingFileGUIDs[0];
                        let filename = $attachmentUploadContainer.synUpload("getFileNameFromGuid", fileGUID);
                        propertyPage.instance.items[filefieldname].value = filename;
                        let options = new PropertyPageModel_1.PropertyPageSetInstanceOptions();
                        options.mode = propertyPage.mode; // new
                        options.parentId = that.m_id;
                        options.propertyPage = propertyPage;
                        options.tagName = that.m_tagNameNew;
                        if (attachmentsRelId)
                            options.parentRelId = Number(attachmentsRelId);
                        yield $attachmentPropertyPage.synPropertyPage("setInstanceWithOptions", options);
                        activateButtons();
                        that.showSaveButtons(true);
                    });
                });
            };
            let nextAttachment = function () {
                if (that.m_remainingFileGUIDs.length > 0) {
                    let fileGUID = that.m_remainingFileGUIDs[0];
                    let filename = $attachmentUploadContainer.synUpload("getFileNameFromGuid", fileGUID);
                    $attachmentPropertyPageContainer.find(".attachmentPropertyPageHeader")
                        .html((fileGUIDs.length - that.m_remainingFileGUIDs.length + 1).toString() + "/" + fileGUIDs.length.toString() + ": " + filename);
                    initAttachmentPropertyPage();
                }
                else {
                    $attachmentPropertyPageContainer.addClass("hide");
                    $attachmentListContainer.removeClass("hide");
                    $attachmentUploadContainer.synUpload("clearList");
                    loadTabContent();
                    that.showSaveButtons(false);
                }
            };
            nextAttachment();
            // Override global button handler
            let activateButtons = function () {
                let eventHandler = "click";
                if ("ontouchstart" in document.documentElement)
                    eventHandler = "touchstart";
                that.m_$wizard.find(".actions").find(".btn-save").off(eventHandler).on(eventHandler, doSavePropertyAttachments);
                that.m_$wizard.find(".actions").find(".btn-revert").off(eventHandler).on(eventHandler, cancelSavePropertyAttachments);
            };
            let cancelSavePropertyAttachments = function (event) {
                if (Utilities_1.synUtil.Configs.getValue("webconfirmcancel") !== "N") {
                    if (window.confirm(Utilities_1.synUtil.Strings.getValue("confirmcancel"))) {
                        that.m_remainingFileGUIDs = [];
                        nextAttachment();
                    }
                }
                else {
                    that.m_remainingFileGUIDs = [];
                    nextAttachment();
                }
            };
            let doSavePropertyAttachments = function (event) {
                if (!that.m_saveInProgress) {
                    that.m_saveInProgress = true;
                    let saveBtn = that.m_$wizard.find(".actions").find(".btn-save");
                    Utilities_1.synUtil.beginAjaxProgress(saveBtn);
                    let fileGUID = that.m_remainingFileGUIDs[0];
                    $attachmentPropertyPage.synPropertyPage("commitChanges", {
                        fileGUIDs: [fileGUID],
                        success(currentInstance, commitResult) {
                            switch (commitResult) {
                                case PropertyPage_1.CommitSuccess.Saved:
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                                    break;
                                case PropertyPage_1.CommitSuccess.Created:
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew"));
                                    that.m_remainingFileGUIDs = _.without(that.m_remainingFileGUIDs, fileGUID);
                                    setTimeout(function () {
                                        nextAttachment();
                                    }, 250);
                                    break;
                                case PropertyPage_1.CommitSuccess.NoChanges:
                                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("nochanges"));
                                    break;
                                default:
                                    break;
                            }
                        },
                        cleanUp() {
                            that.m_saveInProgress = false;
                            Utilities_1.synUtil.endAjaxProgress(saveBtn);
                        },
                        updatePropertyPageAfterCommit: true
                    });
                }
            };
        };
        let createAttachmentsWithoutMetadata = function (fileGUIDs) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                let attachmentsRelId = Utilities_1.synUtil.Configs.getValue("acquisition.attachments.relid", "1" /* RELATION_ALL */, parseInt(that.m_typeId, 10));
                let attachmentTypeId = $attachmentCategoryChooser.synCategoryChooser("getSelectedCategory").id;
                let requestOptions = {
                    typeId: attachmentTypeId,
                    mode: 4 /* NEW */,
                    parentId: that.m_id.toString(),
                    getControls: false
                };
                if (attachmentsRelId)
                    requestOptions.parentRelId = attachmentsRelId;
                let filefieldname = Utilities_1.synUtil.Configs.getValue("acquisition.attachments.filefieldname", "cgdocument.doclabel", attachmentTypeId);
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("PropertypageControlsTemplate"),
                    requestData: requestOptions,
                    done(propertyPageJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let propertyPage = yield PropertyPageModel_1.PropertyPageModel.fromJSON(propertyPageJSON);
                            let instance = propertyPage.instance;
                            let successUploadCnt = 0;
                            _.each(fileGUIDs, function (fileGUID) {
                                let filename = $attachmentUploadContainer.synUpload("getFileNameFromGuid", fileGUID);
                                instance[filefieldname].value = filename;
                                requestOptions.instance = JSON.stringify(instance.toJSON());
                                // Instanzen anlegen
                                requestOptions.fileGUIDs = fileGUID;
                                Utilities_1.synUtil.getAJAXData({
                                    method: "PUT",
                                    url: Utilities_1.synUtil.getWSUrl("InstanceCreate"),
                                    requestData: requestOptions,
                                    done(data) {
                                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                            // everthing ok
                                            let instance = yield Instance_1.Instance.fromJSON(data);
                                            Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew") + ": " + instance.id.value);
                                            successUploadCnt += 1;
                                            if (fileGUIDs.length === successUploadCnt) {
                                                $attachmentUploadContainer.synUpload("clearList");
                                                loadTabContent();
                                            }
                                        });
                                    }
                                });
                            });
                        });
                    }
                });
            });
        };
        // Init Category Chooser
        if (!($attachmentCategoryChooser.data("synCategoryChooser"))) {
            $attachmentCategoryChooser
                .off("initSuccess").on("initSuccess", function (event) {
                let attachmentTypeId = $attachmentCategoryChooser.synCategoryChooser("getSelectedCategory").id;
                loadTabContent();
                that.m_forceMetadata = Utilities_1.synUtil.Configs.getValue("acquisition.attachments.showmetadata", "Y", attachmentTypeId) === "Y" ? true : false;
                that.m_attachmentMode = that.parseAttachmentMode(Utilities_1.synUtil.Configs.getValue("acquisition.attachments.mode", "file", attachmentTypeId));
                showHideAttachmentButtons(that.m_attachmentMode);
            })
                .off("categorySelected").on("categorySelected", function (event, categorySelected) {
                let attachmentTypeId = categorySelected.id;
                loadTabContent();
                that.m_forceMetadata = Utilities_1.synUtil.Configs.getValue("acquisition.attachments.showmetadata", "Y", attachmentTypeId) === "Y" ? true : false;
                that.m_attachmentMode = that.parseAttachmentMode(Utilities_1.synUtil.Configs.getValue("acquisition.attachments.mode", "file", attachmentTypeId));
                showHideAttachmentButtons(that.m_attachmentMode);
            })
                .synCategoryChooser({
                showIcons: true,
                showTreeButton: false,
                showDependsCheckbox: false,
                parentId: that.m_id,
                parentRelId: attachmentsRelId
            });
        }
        if ($attachmentUploadContainer.hasClass("synUpload"))
            showHideAttachmentButtons(that.m_attachmentMode);
        let loadTabContent = function () {
            if (!($attachmentList.synList("isInitialized")))
                $attachmentList.synList({
                    columnOptions: {},
                    dataItemGenerator: (ctx) => {
                        let parentid = that.m_id, relid = attachmentsRelId;
                        return new Promise((resolve) => {
                            if (relid) {
                                Utilities_1.synUtil.getAJAXData({
                                    url: Utilities_1.synUtil.getWSUrl("InstanceChildren") + parentid + "/" + relid,
                                    requestData: {},
                                    done(resultsId, textStatus, jqXHR, handlerKey) {
                                        let headers = {};
                                        if (handlerKey)
                                            headers["X-WS-Affinity"] = handlerKey;
                                        Utilities_1.synUtil.getAJAXData({
                                            method: "POST",
                                            url: Utilities_1.synUtil.getWSUrl("Results") + resultsId,
                                            headers,
                                            requestData: {
                                                fieldNames: JSON.stringify(ctx.columnNames)
                                            },
                                            done: (data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                const children = yield Instance_1.Instance.fromJSONArray(data.data);
                                                resolve(List_1.instancesToListDataItems(children));
                                            })
                                        });
                                    }
                                });
                            }
                            else
                                resolve([]);
                        });
                    }
                });
            else
                $attachmentList.synList("refresh");
        };
        loadTabContent();
        // ------------------- BEGIN EVENT HANDLERS -------------------
        // showAttachmentsPropertyPage(false);
    }
    initStepDownload() {
        let that = this;
        that.m_$wizardContainer.find("button.download").off("click").on("click", function () {
            synerisMethods_1.synerisMethods.cefunc["26"].impl([that.m_id], undefined, undefined, undefined);
        });
    }
    parseAttachmentMode(mode) {
        let m = mode.toLowerCase();
        if (m === "fileandmeta")
            return AttachmentMode.File | AttachmentMode.Metadata;
        else if (m === "meta")
            return AttachmentMode.Metadata;
        return AttachmentMode.File;
    }
    setNewButtonVisibility(templateSelected) {
        let that = this;
        let $newButton = that.m_$openDocuments.find(".new");
        if ($newButton) {
            if (Utilities_1.synUtil.Configs.getValue("acquisition.initstep", "metadata", parseInt(that.m_typeId, 10)) === "checklist" && !templateSelected)
                $newButton.attr("disabled", "disabled");
            else
                $newButton.removeAttr("disabled");
        }
    }
    initOpenDocuments() {
        let that = this;
        that.m_$openDocuments.removeClass("hide");
        that.m_$wizardContainer.addClass("hide");
        // Strings for the listview
        let template = kendo.template(that.m_config.openDocumentTemplate);
        let templateStrings = {
            continue: Utilities_1.synUtil.Strings.getValue("acquisition.document.continue", undefined, parseInt(that.m_typeId, 10)),
            cancel: Utilities_1.synUtil.Strings.getValue("acquisition.document.cancel", undefined, parseInt(that.m_typeId)),
            new: Utilities_1.synUtil.Strings.getValue("acquisition.document.new", undefined, parseInt(that.m_typeId)),
            description: Utilities_1.synUtil.Strings.getValue("acquisition.opendocuments.description", undefined, parseInt(that.m_typeId))
        };
        // set Strings for description and new
        that.m_$openDocuments.find(".description").html(templateStrings.description);
        let $newButton = that.m_$openDocuments.find(".new")
            .html("<i class='fa fa-file'></i>" + kendo.htmlEncode(templateStrings.new));
        if ((that.m_$openDocumentList.data("kendoListView")))
            that.m_$openDocumentList.data("kendoListView").setDataSource(that.m_openDocumentsDS);
        else {
            that.m_$openDocumentList.kendoListView({
                dataSource: that.m_openDocumentsDS,
                template(item) {
                    item.strings = templateStrings;
                    let itemRow = template(item);
                    return itemRow;
                }
            });
            // Delegate the button handlers
            that.m_$openDocumentList.undelegate("button.accept", "click").delegate("button.accept", "click", function () {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    let docId = $(this).closest("tr").data("id").split("_")[1];
                    yield that.initWizard(docId);
                });
            });
            that.m_$openDocumentList.undelegate("button.deny", "click").delegate("button.deny", "click", function () {
                let docId = $(this).closest("tr").data("id").split("_")[1];
                that.deleteDocument(docId);
            });
            $newButton.off("click").on("click", function () {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    yield that.initWizard(undefined);
                });
            });
        }
    }
    deleteDocument(id) {
        let that = this;
        if (id) {
            let delIds = [id];
            let attachmentsRelId = Utilities_1.synUtil.Configs.getValue("acquisition.attachments.relid", "1" /* RELATION_ALL */, parseInt(that.m_typeId, 10));
            if (attachmentsRelId) {
                Utilities_1.synUtil.getAJAXData({
                    url: Utilities_1.synUtil.getWSUrl("InstanceChildren") + id + "/" + attachmentsRelId,
                    requestData: {},
                    done(data, textStatus, jqXHR, handlerKey) {
                        let resultUrl = Utilities_1.synUtil.getWSUrl("Results") + data;
                        Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            headers: { "X-WS-Affinity": handlerKey },
                            url: resultUrl,
                            requestData: {
                                fieldNames: JSON.stringify([id]),
                                oneShot: "true"
                            },
                            done(dataJSON) {
                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    let instances = yield Instance_1.Instance.fromJSONArray(dataJSON.data);
                                    _.each(instances, function (item) {
                                        delIds.push(item.id.value);
                                    });
                                    that.callDelete(delIds);
                                });
                            }
                        });
                    }
                });
            }
            else
                that.callDelete(delIds);
        }
        else
            that.initWidgets();
    }
    callDelete(delIds) {
        let that = this;
        synerisMethods_1.synerisMethods.cefunc["24"].impl(delIds, undefined, undefined, function () {
            that.m_id;
            that.initWidgets();
        });
    }
    addStep(stepname, stepMarkup) {
        this.m_steps.push(stepname);
        let oneStepMarkup = stepMarkup.find("." + stepname);
        this.m_$wizard.wizard("addSteps", -1, [{
                badge: this.m_steps.length + 1,
                label: oneStepMarkup.find(".label").html(),
                pane: oneStepMarkup.find(".pane").html()
            }]);
    }
    editDocument(edit) {
        this.showSaveButtons(edit);
    }
    activateButtons() {
        let that = this;
        let eventHandler = "click";
        if ("ontouchstart" in document.documentElement)
            eventHandler = "touchstart";
        that.m_$wizard.find(".actions").find(".btn-save").off(eventHandler).on(eventHandler, function (event) {
            if (that.m_mode === Mode.Checklist) {
                if (!that.m_saveInProgress) {
                    that.m_saveInProgress = true;
                    let saveBtn = that.m_$wizard.find(".actions").find(".btn-save");
                    Utilities_1.synUtil.beginAjaxProgress(saveBtn);
                    let newInst = that.m_$checklistEditorPage.synChecklist("getInstance");
                    Utilities_1.synUtil.getAJAXData({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("ChecklistCheckMandatory"),
                        requestData: {
                            instance: JSON.stringify(newInst),
                            id: that.m_checklistId,
                        },
                        done() {
                            that.m_$checklistEditorPage.synChecklist("save", undefined, false, that.m_checklistId, undefined, parseInt(that.m_typeId, 10), {
                                success(savedInstance) {
                                    if (savedInstance["synerisid"]) {
                                        that.m_id = savedInstance["synerisid"];
                                        that.m_checklistId = savedInstance["synerisid"];
                                    }
                                    that.m_checklistAction = ChecklistControls_1.ChecklistAction.Edit;
                                    that.m_saveInProgress = false;
                                    that.enableNextStep(true);
                                    that.enableCancel(true);
                                }, cleanUp() {
                                    that.m_saveInProgress = false;
                                    that.editDocument(false);
                                    Utilities_1.synUtil.endAjaxProgress(saveBtn);
                                },
                            });
                        },
                        fail(jqXHR, textStatus, errorThrown, url) {
                            Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url, false);
                            that.m_saveInProgress = false;
                            Utilities_1.synUtil.endAjaxProgress(saveBtn);
                        }
                    });
                }
            }
            else {
                if (!that.m_saveInProgress) {
                    that.m_saveInProgress = true;
                    let saveBtn = that.m_$wizard.find(".actions").find(".btn-save");
                    Utilities_1.synUtil.beginAjaxProgress(saveBtn);
                    that.m_$propertyPage.synPropertyPage("commitChanges", {
                        success(currentInstance, commitResult) {
                            switch (commitResult) {
                                case PropertyPage_1.CommitSuccess.Saved:
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                                    break;
                                case PropertyPage_1.CommitSuccess.Created:
                                    that.m_id = currentInstance.id.value;
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew"));
                                    that.enableNextStep(true);
                                    that.enableCancel(true);
                                    break;
                                case PropertyPage_1.CommitSuccess.NoChanges:
                                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("nochanges"));
                                    break;
                                default:
                                    break;
                            }
                            that.m_saveInProgress = false;
                        },
                        cleanUp() {
                            that.m_saveInProgress = false;
                            that.editDocument(false);
                            Utilities_1.synUtil.endAjaxProgress(saveBtn);
                        },
                        updatePropertyPageAfterCommit: true
                    }, that.m_tagNameEdit);
                }
            }
        });
        this.m_$wizard.find(".actions").find(".btn-revert").off(eventHandler).on(eventHandler, function (event) {
            if (Utilities_1.synUtil.Configs.getValue("webconfirmcancel") !== "N") {
                if (window.confirm(Utilities_1.synUtil.Strings.getValue("confirmcancel"))) {
                    that.m_$propertyPage.synPropertyPage("refresh");
                    that.editDocument(false);
                }
            }
            else {
                that.m_$propertyPage.synPropertyPage("refresh");
                that.editDocument(false);
            }
        });
    }
    showSaveButtons(show) {
        let that = this;
        let $navButtons = that.m_$wizard.find(".actions").find("button.btn-prev, button.btn-next, button.btn-cancel");
        let $saveButtons;
        if (that.m_mode === Mode.Checklist)
            $saveButtons = that.m_$wizard.find(".actions").find("button.btn-save, button.btn-cancel");
        else
            $saveButtons = that.m_$wizard.find(".actions").find("button.btn-save, button.btn-revert");
        if (show) {
            $navButtons.addClass("hide");
            $saveButtons.removeClass("hide");
        }
        else {
            $saveButtons.addClass("hide");
            $navButtons.removeClass("hide");
        }
    }
    enableNextStep(enable) {
        if (enable)
            this.m_$wizard.find(".btn-next").removeAttr("disabled");
        else
            this.m_$wizard.find(".btn-next").attr("disabled", "disabled");
    }
    enableCancel(enable) {
        if (enable)
            this.m_$wizard.find(".btn-cancel").removeAttr("disabled");
        else
            this.m_$wizard.find(".btn-cancel").attr("disabled", "disabled");
    }
    addOpenDocumentsForCategory(typeid, callback) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let dataSourceTmp = new kendo.data.DataSource();
            let instance = yield Instance_1.Instance.fromSearchData({
                "cgdocument.typeid": typeid.toString(),
                "cgdocument.owner": "#variable.currentuser#",
                "cgdocument.stateid": Utilities_1.synUtil.Configs.getValue("initstate", undefined, parseInt(that.m_typeId)),
            });
            if (that.m_mode === Mode.Checklist)
                yield instance.addSearchField("cgdocument.prodid", "41003");
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("Search"),
                requestData: { query: JSON.stringify(instance.toJSON()) },
                done(resultsId, textStatus, jqXHR, handlerKey) {
                    let url = Utilities_1.synUtil.getWSUrl("Results") + resultsId;
                    Utilities_1.synUtil.getAJAXData({
                        method: "POST",
                        url,
                        headers: { "X-WS-Affinity": handlerKey },
                        requestData: {
                            fieldNames: JSON.stringify(that.m_config.openDocumentFields),
                            oneShot: "true"
                        },
                        done(dataJSON) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let instances = yield Instance_1.Instance.fromJSONArray(dataJSON.data);
                                _.each(instances, function (item) {
                                    dataSourceTmp.add(that.prepareNode(item));
                                });
                                that.m_openDocumentsDS = dataSourceTmp;
                                callback(dataJSON.total);
                            });
                        }
                    });
                }
            });
        });
    }
    prepareNode(dataNode) {
        let that = this;
        let resultInstance = {};
        $.each(dataNode.items, function (index, field) {
            if (field.multiValue) {
                let str = "";
                let valueAsArray = field.valueAsArray;
                for (let i = 0; i < valueAsArray.length; i++) {
                    if (i > 0)
                        str += ";";
                    let elem = valueAsArray[i];
                    str += that.fieldValueToString(field.type, elem);
                }
                resultInstance[field.name.replace(/\./g, "_")] = str;
            }
            else {
                resultInstance[field.name.replace(/\./g, "_")] = that.fieldValueToString(field.type, field.value);
                resultInstance[field.name.replace(/\./g, "_") + "_orig"] = field.value;
            }
        });
        resultInstance["id"] = dataNode.id.value;
        resultInstance["id_orig"] = dataNode.id.value; // Ist das wirklich notwendig? Wurde nur aufgenommen, weil die Datenstruktur vor Umbau auf Instance so ausgesehen hat.
        if (dataNode.icon.value) {
            resultInstance["icon"] = dataNode.icon.value;
            resultInstance["icon_orig"] = dataNode.icon.value; // Ist das wirklich notwendig? Wurde nur aufgenommen, weil die Datenstruktur vor Umbau auf Instance so ausgesehen hat.
        }
        if (dataNode.name.value) {
            resultInstance["name"] = dataNode.name.value;
            resultInstance["name_orig"] = dataNode.name.value; // Ist das wirklich notwendig? Wurde nur aufgenommen, weil die Datenstruktur vor Umbau auf Instance so ausgesehen hat.
        }
        if (dataNode.treename.value) {
            resultInstance["treename"] = dataNode.treename.value;
            resultInstance["treename_orig"] = dataNode.treename.value; // Ist das wirklich notwendig? Wurde nur aufgenommen, weil die Datenstruktur vor Umbau auf Instance so ausgesehen hat.
        }
        if (dataNode.comment.value) {
            resultInstance["comment"] = dataNode.comment.value;
            resultInstance["comment_orig"] = dataNode.comment.value; // Ist das wirklich notwendig? Wurde nur aufgenommen, weil die Datenstruktur vor Umbau auf Instance so ausgesehen hat.
        }
        if (resultInstance["icon"])
            resultInstance.imageUrl = Utilities_1.synUtil.getWSUrl("Icon") + resultInstance["icon"] + "/16";
        if (!resultInstance.imageUrl)
            resultInstance.imageUrl = Utilities_1.synUtil.getWSUrl("Icon") + "transparent";
        resultInstance.$id = resultInstance.id.replace(/\|/g, "_");
        return resultInstance;
    }
    fieldValueToString(type, value) {
        if (type && value) {
            if (type === Base_1.FieldType.Date)
                return kendo.toString(Utilities_1.synUtil.jsonToDate(value), "d");
            else if (type === Base_1.FieldType.DateTime)
                return kendo.toString(Utilities_1.synUtil.jsonToDateTime(value), "G");
            else if (type === Base_1.FieldType.Time)
                return kendo.toString(Utilities_1.synUtil.jsonToTime(value), "T");
            else if (type === Base_1.FieldType.Bool)
                return value ? "Y" : "N";
            else if (type === Base_1.FieldType.Float)
                return kendo.toString(value, "n2");
            return value.toString();
        }
        return "";
    }
}
exports.acquisition = acquisition;
